import styled from 'styled-components';

const SLink = styled.a`
  color: ${({ color, theme }) => color ?? theme.colors.primaryText};
  align-items: center;
  cursor: pointer;
  display: inline-block;
  font-size: 1rem;
  text-decoration-thickness: 1px;
  text-decoration: underline;
  text-underline-offset: 3px;

  span {
    align-items: center;
    color: ${({ theme }) => theme.colors.primaryText};
    display: flex;

    &.xs {
      font-size: 0.78125rem;
    }

    &.s {
      font-size: 0.9375rem;
    }

    &.m {
      font-size: 1.0935rem;
    }

    &.l {
      font-size: 1.25rem;
    }

    &.xl {
      font-size: 1.5625rem;
    }
  }

  svg {
    margin-right: 5px;
  }

  path {
    fill: ${({ theme }) => theme.colors.primary};
  }

  &.no-underline {
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
      text-decoration-color: ${({ theme }) => theme.colors.tertiaryBorder};
    }
  }

  &.disabled {
    color: ${({ theme }) => theme.colors.quaternaryText};
    text-decoration-color: ${({ theme }) => theme.colors.quaternaryText};

    span {
      color: ${({ theme }) => theme.colors.quaternaryText};
    }

    path {
      fill: ${({ theme }) => theme.colors.quaternaryText};
    }
  }

  &:hover:not(.disabled),
  &:focus,
  &.no-underline:hover:not(.disabled) {
    text-decoration-color: ${({ theme }) => theme.colors.tertiaryBorder};

    path {
      fill: ${({ theme }) => theme.colors.tertiaryBorder};
    }
  }

  &:hover,
  &:focus {
    text-decoration-thickness: 2px;
  }

  &.disabled.no-underline:hover {
    text-decoration: none;
  }

  &:active {
    text-decoration-color: ${({ theme }) => theme.colors.tertiaryBorder};
    text-decoration-thickness: 1px;
  }

  &:focus {
    outline: 0;
  }

  &.large {
    font-size: 2rem;

    svg {
      margin-right: 15px;
    }
  }

  &.primary {
    text-decoration-color: ${({ theme }) => theme.colors.primary};
  }

  &.secondary {
    text-decoration-color: ${({ theme }) => theme.colors.primaryText};

    path {
      fill: ${({ theme }) => theme.colors.primaryText};
    }

    &.disabled {
      text-decoration-color: ${({ theme }) => theme.colors.quaternaryText};
    }
  }

  &.white {
    text-decoration-color: ${({ theme }) => theme.colors.primary};

    span {
      color: #fff;
    }

    &.disabled {
      text-decoration-color: ${({ theme }) => theme.colors.tertiaryText};

      span {
        color: ${({ theme }) => theme.colors.tertiaryText};
      }

      path {
        fill: ${({ theme }) => theme.colors.tertiaryText};
      }
    }
  }
`;

export default SLink;
